import { useParams } from "react-router-dom";

import TractorDriverForm from './jobForms/TractorDriverForm';
import DronePilotForm from "./jobForms/DronePilotForm";
import SoftwareEngineerForm from "./jobForms/SoftwareEngineerForm";
import WarehouseInchargeForm from "./jobForms/WarehouseInchargeForm";
import MachineryControllerForm from "./jobForms/MachineryControllerForm";
import MarketingForm from "./jobForms/MarketingForm";

export default function JobApply({ user }) {
  const { jobType } = useParams();

  switch (jobType) {
    case "tractor-driver":
      return <TractorDriverForm user={user} />;

    case "drone-pilot":
      return <DronePilotForm user={user} />;

    case "software-engineer":
      return <SoftwareEngineerForm user={user} />;

    case "warehouse-incharge":
      return <WarehouseInchargeForm user={user} />;

    case "machinery-controller":
      return <MachineryControllerForm user={user} />;

    case "marketing":
      return <MarketingForm user={user} />;

    default:
      return <h2 style={{ textAlign: "center" }}>Invalid Job</h2>;
  }
}
